import { Link } from "react-router-dom";
import { ArrowRight, Check, Lock, ShoppingBag, Zap } from "lucide-react";
import { useProductVaultCheckout } from "../../hooks/useProductVaultCheckout";
import { gbp } from "../../lib/store";

export function StoreBuyButton({ product, size = "lg", source = "store" }) {
  const { buying, buyTrack } = useProductVaultCheckout(product.slug);
  const tid = (base) => (source === "store_product" ? base : `${base}-${source}`);
  const pad = size === "lg" ? "px-6 py-3.5 text-xs" : "px-5 py-3 text-xs";
  if (product.owned) {
    return (
      <Link to={`/vault/${product.slug}`} className={`inline-flex items-center gap-2 border border-emerald-500/60 text-emerald-300 hover:bg-emerald-500/10 ${pad} tracking-[0.25em] uppercase font-bold transition-colors`} data-testid={tid("store-open-track")}>
        <Check size={16} /> You own this — {product.store_copy?.open_label || "open the track"}
      </Link>
    );
  }
  if (product.purchasable) {
    return (
      <div className="flex flex-col items-start gap-3 max-w-full">
        <button type="button" onClick={() => buyTrack(source)} disabled={buying} className={`store-glow inline-flex items-center gap-3 bg-purple-500 hover:bg-purple-400 text-black ${pad} tracking-[0.25em] uppercase font-bold transition-all duration-300 disabled:opacity-50`} data-testid={tid("store-unlock-button")}>
          <ShoppingBag size={16} /> {buying ? "Opening checkout…" : `Buy this track · ${gbp(product.price)}`} <ArrowRight size={16} />
        </button>
        <Link to="/pricing" className={`inline-flex items-center gap-2 border border-purple-500 text-purple-200 hover:bg-purple-500/10 ${pad} tracking-[0.2em] uppercase font-bold transition-colors`} data-testid={tid("store-upgrade-link")}>
          <Zap size={14} /> Stag Vault Complete · £25
        </Link>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-start gap-3 max-w-full" data-testid={tid("store-not-live")}>
      <span className={`inline-flex items-center gap-2 border border-zinc-700 text-zinc-400 ${pad} tracking-[0.2em] uppercase font-bold cursor-default`}>
        <Lock size={14} /> Single-track opens soon · {gbp(product.price)}
      </span>
      <Link to="/pricing" className={`inline-flex items-center gap-2 border border-purple-500 text-purple-200 hover:bg-purple-500/10 ${pad} tracking-[0.2em] uppercase font-bold transition-colors`} data-testid={tid("store-upgrade-link")}>
        <Zap size={14} /> Stag Vault Complete · £25
      </Link>
    </div>
  );
}
